"use client"

import '@/styles/landing.css';
import { useThemeMode } from '@/lib/themes/theme-mode';
import { dashboardThemeVars } from '@/lib/themes/dashboard-theme-vars';
import {LandingHeader} from "@/components/landing/header";

export default function LandingLayout({
                                          children,
                                      }: Readonly<{
    children: React.ReactNode;
}>) {
    const { theme } = useThemeMode();

    return (
        <div
            className="landing-scope min-h-screen flex flex-col"
            style={dashboardThemeVars(theme)}
        >
            <LandingHeader />
            <main className="flex-1">{children}</main>
        </div>
    );
}